import classNames from 'classnames';
import { DisplayWhenHasModules } from 'components.layouts/five-up/five-up-utils.js';
import { StickyBar } from 'components.layouts/layout-sticky-bar.js';
import { SecondaryNavigationEntry } from 'components/navigation/secondary-nav-entry.js';
import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { SecondarySectionMain } from 'layout/sections/secondary-section/secondary-main.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { filterPrimaryConfig } from 'page/layout-areas.js';
import * as React from 'react';
import { reduxInitialStateLayout } from 'redux-state/layout/reducer.js';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { MapHeaders } from './map-headers.js';
import { MapLeftSlot } from './map-left-slot.js';
import { MapToRender } from './map-toRender.js';

/**
 * Renders map layout with slots over the top of map canvas
 * MapSlot callback is passed to map which is used to update map slot on icon select
 */
export const MapLayoutCore = ({ data }: { data?: ILayoutConfig }) => {
  const columnLayout = React.useContext(ColumnLayoutContext);
  const { primary, map, mobileView } = data ?? reduxInitialStateLayout().screen.layout;

  const filteredPrimaryConfig = React.useMemo(
    () => filterPrimaryConfig(primary?.slots, columnLayout),
    [primary.slots, columnLayout],
  );

  const hasRightSlot =
    filteredPrimaryConfig.rightMajor.modules.concat(filteredPrimaryConfig.rightMinor.modules).length > 0;

  if (data) {
    return (
      <>
        <StickyBar name={data.name}>
          <>
            <SecondaryNavigationEntry />
            <MapHeaders data={data}>
              <>
                <MapLeftSlot filteredPrimaryConfig={filteredPrimaryConfig} mobileView={mobileView}>
                  <MapToRender map={map} />
                </MapLeftSlot>
                {hasRightSlot && (
                  <div className="Layout-sidebar Grid-cell u-xl-mB-lg u-lg-hidden u-mT-ssm u-md-mT-0 u-xl-width3of12 u-xl-inlineBlock">
                    <DisplayWhenHasModules section={filteredPrimaryConfig.rightMajor}>
                      <ModulesLazyLoadWrapper
                        section={getModulesMetaData('map-rightMajor', filteredPrimaryConfig.rightMajor.modules)}
                        className={classNames({ 'u-mB-responsive': columnLayout === '1-column' })}
                      >
                        <ModuleArrLoad
                          modules={filteredPrimaryConfig.rightMajor.modules}
                          modulePath={ModulePath.PRIMARY_RIGHT_MAJOR}
                        />
                      </ModulesLazyLoadWrapper>
                    </DisplayWhenHasModules>

                    <DisplayWhenHasModules section={filteredPrimaryConfig.rightMinor}>
                      <ModulesLazyLoadWrapper
                        section={getModulesMetaData('map-rightMinor', filteredPrimaryConfig.rightMinor.modules)}
                        className={classNames({ 'u-mB-responsive': columnLayout === '1-column' })}
                      >
                        <ModuleArrLoad
                          modules={filteredPrimaryConfig.rightMinor.modules}
                          modulePath={ModulePath.PRIMARY_RIGHT_MINOR}
                        />
                      </ModulesLazyLoadWrapper>
                    </DisplayWhenHasModules>
                  </div>
                )}
              </>
            </MapHeaders>
          </>
        </StickyBar>
        <SecondarySectionMain />
      </>
    );
  }
  return null;
};
